import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {trackEvent} from '../../tracking/amplitude/TrackingV2';
import {DeclarativeMutationConfig} from 'relay-runtime/lib/mutations/RelayDeclarativeMutationConfig';
import {Disposable, Environment} from 'relay-runtime';
import {
	DeleteDeliverableInput,
	DeleteDeliverableMutation,
	DeleteDeliverableMutation$rawResponse,
} from './__generated__/DeleteDeliverableMutation.graphql';
import {omit} from 'lodash';

const mutation = graphql`
	mutation DeleteDeliverableMutation($input: DeleteDeliverableInput!) @raw_response_type {
		deleteDeliverable(input: $input) {
			deletedDeliverableId
		}
	}
`;

function getConfigs(input): DeclarativeMutationConfig[] {
	return [
		{
			type: 'RANGE_DELETE',
			parentID: input.projectId,
			connectionKeys: [
				{
					key: 'Project_deliverables',
				},
			],
			pathToConnection: ['project', 'deliverables'],
			deletedIDFieldName: 'deletedDeliverableId',
		},
	];
}

function getOptimisticResponse(input: DeleteDeliverableInput): DeleteDeliverableMutation$rawResponse {
	return {
		deleteDeliverable: {
			deletedDeliverableId: input.id,
		},
	};
}
function commit(
	environment: Environment,
	input: DeleteDeliverableInput,
	onSuccess?: (response) => void,
	onError?: (error: Error) => void
): Disposable {
	trackEvent('Deliverable', 'Deleted', input);

	const cleanedInput = omit(input, ['projectId']) as Omit<DeleteDeliverableInput, 'projectId'>;

	const variables = {
		input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...cleanedInput},
	};

	return commitMutation<DeleteDeliverableMutation>(environment, {
		mutation,
		variables,
		configs: getConfigs(input),
		optimisticResponse: getOptimisticResponse(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
